import { Platform, StyleSheet } from 'react-native'

import { moderateScale } from '../../styles/sizes'
import { fontFamily } from '../../theme/fontFamily'

export const styles = StyleSheet.create({
  buttonStyle: {
    backgroundColor: '#121212',
    height: moderateScale(48),
    borderRadius: 48,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    position: 'relative',
    width: Platform.OS === 'web' ? 300 : '100%'
  },
  buttonView: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonText: {
    color: '#FFFFFF',
    fontWeight: '500',
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardMedium
  },
  loadingStyle: {
    right: 20,
    position: 'absolute'
  },
  // Add new design styles
  container: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: '#E9E238'
  },
  closeIconStyle: {
    tintColor: '#121212'
  },
  PracticeIcon: {
    height: 134,
    width: 134
  },
  mainContainer: {
    flex: 1,
    backgroundColor: '#E9E238',
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    color: '#121212',
    fontWeight: '400',
    fontSize: 32,
    fontFamily: fontFamily.FeatureDeckRegular,
    textAlign: 'center',
    marginVertical: 20
  },
  description: {
    color: '#121212',
    fontWeight: '400',
    fontSize: 18,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    textAlign: 'center'
  },
  botContainer: {
    marginTop: 20,
    // height: 50,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  botView: {
    height: 40,
    width: 40,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#121212',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 5,
    alignSelf: 'center'
  },
  botText: {
    color: '#121212',
    fontWeight: '700',
    fontSize: 12,
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  checkboxContainer: {
    marginVertical: 10,
    // flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    // alignSelf: 'flex-start',
    marginLeft: 4,
    height: 30
  },
  checkboxIcon: {
    height: 20,
    width: 20,
    resizeMode: 'contain',
    marginRight: 8
  },
  blindText: {
    color: '#121212',
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    textAlign: 'center'
  },
  dropdown: {
    width: '100%',
    height: 48,
    backgroundColor: '#E9E238',
    borderRadius: 8,
    fontSize: moderateScale(16),
    paddingStart: 10,
    marginTop: 8,
    borderWidth: 1,
    borderColor: '#121212',
    fontFamily: fontFamily.FeatureDeckRegular
  },
  dropdownPickerImage: {
    width: 16,
    height: 16,
    resizeMode: 'contain',
    tintColor: '#121212'
  },
  emptyView: {
    height: 48,
    marginTop: 8
  },
  noText: {
    color: '#121212',
    fontFamily: fontFamily.GTAmericaExtended,
    fontSize: 14
  }
})
